import React from 'react';
import { map } from 'lodash';
import ThicknessIcon from './ThicknessIcon';

export const thicknessOptions = map(
  [
    { key: 's', label: 'Small', pencilPx: 4, highlighterPx: 24, textboxPx: 60 },
    {
      key: 'm',
      label: 'Medium',
      pencilPx: 8,
      highlighterPx: 48,
      textboxPx: 100,
    },
    {
      key: 'l',
      label: 'Large',
      pencilPx: 16,
      highlighterPx: 96,
      textboxPx: 140,
    },
    {
      key: 'xl',
      label: 'XL',
      pencilPx: 32,
      highlighterPx: 192,
      textboxPx: 180,
    },
  ],
  ({ key, label, pencilPx, highlighterPx, textboxPx }) => ({
    key,
    label,
    pencilPx,
    highlighterPx,
    textboxPx,
    icon: () => <ThicknessIcon label={key} />,
  })
);
